export class AovVerzekerde {
    style: string = '';
    birthdate: string = '';
    hoursPerWeekAdministrativeWork: number = 0;
    hoursPerWeekManagement: number = 0;
    hoursPerWeekCommercial: number = 0;
    hoursPerWeekManualLabour: number = 0;
    kilometersPerYearTravel: number = 0;
    highestEducation: string = '';
    occupation: string = '';
    yearlyIncome: number = 0;
    insuredAmount: number = 0;
    benefitIndexationMethod: string = '';
    indexationOfBenefit: boolean = false;
    indexationOfInsuredAmount: boolean = false;
    waitingDays: number = 0;
}